/**
 * judge 是否是上海的桶 > -1 是
 * cos 的 key
 */
import {Notify} from '@nutui/nutui'
export default (judge, key, data, cos) => {
    return new Promise((res, rej) => {
        if(judge > -1){
            cos.uploadFile(
                {
                    Bucket: "ishare-10003415" /* 必须 */,
                    Region: "ap-shanghai" /* 存储桶所在地域，必须字段 */,
                    Key: key /* 必须 */,
                    StorageClass: "STANDARD",
                    Body: JSON.stringify(data), // 上传文件对象
                    onProgress: function() {},
                    SliceSize: 1024 * 1024 * 1,
                },
                function(err, datas) {
                    console.log(err, 'errs');
                    console.log(datas, 'datas');
                    if (err) {
                        Notify.warn("上传失败");
                        rej(err)
                    }
                    res(datas)
                }
            );
        }else{
            cos.uploadFile(
                {
                  Bucket: 'mapugc-user-1251316161' /* 必须 */,
                    // Region: 'ap-shanghai' /* 存储桶所在地域，必须字段 */,
                  Region: 'ap-beijing' /* 存储桶所在地域，例如ap-beijing，必须字段 */,
                  Key: key /* 必须 */,
                  StorageClass: "STANDARD",
                  Body: JSON.stringify(data), // 上传文件对象
                  onProgress: function() {},
                  SliceSize: 1024 * 1024 * 1,
                },
                function(err, datas) {
                  console.log(err,'err');
                  console.log(datas,'data');
                  if (err) {
                    Notify.warn("上传失败");
                    rej(err)
                  }
                  res(datas)
                }
            );
        }
    })
}